"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var utils_1 = require("ethers/utils");
var browser_1 = __importDefault(require("@walletconnect/browser"));
var _1 = require(".");
var utils_2 = require("@walletconnect/utils");
var WalletConnectWallet = function (_super) {
  __extends(WalletConnectWallet, _super);
  function WalletConnectWallet(opts) {
    var _this = _super.call(this) || this;
    _this.NeedUnlockWalletError = new Error("WalletConnect session not established");
    _this.NotSupportedError = new Error("Current Wallet Not Supported");
    _this._bridge = opts.bridge || "https://bridge.walletconnect.org";
    _this.connector = new browser_1.default({
      bridge: _this._bridge
    });
    return _this;
  }
  WalletConnectWallet.prototype.signMessage = function (message) {
    var _this = this;
    return new Promise(function (resolve, reject) {
      if (!_this.connector.connected) {
        reject(_this.NeedUnlockWalletError);
        return;
      }
      _this.connector.signMessage([_this.connector.accounts[0], message.indexOf("0x") === 0 ? message : utils_2.convertUtf8ToHex(message)]).then(function (signature) {
        return resolve(signature);
      }).catch(function (error) {
        return reject(error);
      });
    });
  };
  WalletConnectWallet.prototype.signPersonalMessage = function (message) {
    var _this = this;
    return new Promise(function (resolve, reject) {
      if (!_this.connector.connected) {
        reject(new Error("WalletConnect session not estabslished"));
        return;
      }
      _this.connector.signPersonalMessage([message.indexOf("0x") === 0 ? message : utils_2.convertUtf8ToHex(message), _this.connector.accounts[0]]).then(function (signature) {
        return resolve(signature);
      }).catch(function (error) {
        return reject(error);
      });
    });
  };
  WalletConnectWallet.prototype.sendTransaction = function (txParams) {
    var _this = this;
    return new Promise(function (resolve, reject) {
      if (!_this.connector.connected) {
        reject(_this.NeedUnlockWalletError);
        return;
      }
      _this.connector.sendTransaction({
        from: txParams.from || _this.connector.accounts[0],
        to: txParams.to || "",
        data: txParams.data || "",
        value: new utils_1.BigNumber("" + txParams.value).toString() || "",
        gasPrice: new utils_1.BigNumber("" + txParams.gasPrice).toString() || "",
        gasLimit: new utils_1.BigNumber("" + txParams.gasLimit).toString() || ""
      }).then(function (txHash) {
        return resolve(txHash);
      }).catch(function (error) {
        return reject(error);
      });
    });
  };
  WalletConnectWallet.prototype.signTransaction = function (txParams) {
    var _this = this;
    return new Promise(function (resolve, reject) {
      if (!_this.connector.connected) {
        reject(_this.NeedUnlockWalletError);
        return;
      }
      _this.connector.signTransaction({
        from: txParams.from || _this.connector.accounts[0],
        to: txParams.to || "",
        data: txParams.data || "",
        value: new utils_1.BigNumber("" + txParams.value).toString() || "",
        gasPrice: new utils_1.BigNumber("" + txParams.gasPrice).toString() || "",
        gasLimit: new utils_1.BigNumber("" + txParams.gasLimit).toString() || ""
      }).then(function (txHash) {
        return resolve(txHash);
      }).catch(function (error) {
        return reject(error);
      });
    });
  };
  WalletConnectWallet.prototype.sendCustomRequest = function (method, params) {
    var _this = this;
    return new Promise(function (resolve) {
      if (!_this.connector.connected) {
        resolve({
          error: _this.NeedUnlockWalletError
        });
        return;
      }
      _this.connector.sendCustomRequest({
        method: method,
        params: params
      }).then(function (txHash) {
        return resolve(txHash);
      }).catch(function (error) {
        return resolve({
          error: error
        });
      });
    });
  };
  WalletConnectWallet.prototype.getAddresses = function () {
    var _this = this;
    return new Promise(function (resolve, reject) {
      if (!_this.connector.connected) {
        resolve([]);
      }
      resolve(_this.connector.accounts);
    });
  };
  WalletConnectWallet.prototype.loadNetworkId = function () {
    var _this = this;
    return new Promise(function (resolve, reject) {
      return resolve(Number(_this.connector.chainId));
    });
  };
  WalletConnectWallet.prototype.isLocked = function () {
    return !this.connector.connected;
  };
  WalletConnectWallet.prototype.type = function () {
    return WalletConnectWallet.TYPE;
  };
  WalletConnectWallet.prototype.id = function () {
    return WalletConnectWallet.TYPE;
  };
  WalletConnectWallet.prototype.isSupported = function () {
    var isSupported = typeof window !== "undefined" && typeof window.location !== "undefined" && window.location.protocol !== "https:" && window.location.hostname !== "localhost";
    if (!isSupported) {
      throw this.NotSupportedError;
    }
    return isSupported;
  };
  WalletConnectWallet.prototype.clearSession = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.connector.killSession()];
          case 1:
            _a.sent();
            return [2];
        }
      });
    });
  };
  WalletConnectWallet.prototype.name = function () {
    return "WalletConnect";
  };
  WalletConnectWallet.LABEL = "WalletConnect";
  WalletConnectWallet.TYPE = "WALLETCONNECT";
  return WalletConnectWallet;
}(_1.BaseWallet);
exports.default = WalletConnectWallet;